import React, {Component} from 'react';
import {action, observable, computed} from 'mobx';
import {inject, observer} from 'mobx-react';
import {Button, FormInput, FormSelect, Modal, ModalBody, ModalHeader} from 'shards-react';
import FeatherIcon from 'feather-icons-react';
import {toast} from 'react-toastify';
import moment from 'moment';
import PageTitle from '../../../components/common/PageTitle';
import './style.scss';
import './reviewToInsta.scss';

const RATIOS = [
  {value: '1:1',  label: '1:1 정사각', w: 1080, h: 1080},
  {value: '4:5',  label: '4:5 세로',   w: 1080, h: 1350},
  {value: '9:16', label: '9:16 스토리', w: 1080, h: 1920}
];

const TEMPLATES = [
  {value: 'quote',     label: '인용 (큰 따옴표)', icon: 'message-square'},
  {value: 'card',      label: '카드 (별점+텍스트)', icon: 'credit-card'},
  {value: 'photo',     label: '포토 (이미지+캡션)', icon: 'image'},
  {value: 'minimal',   label: '미니멀 (텍스트 중심)', icon: 'type'}
];

const PRESET_BG = [
  {bg: '#FFFFFF', fg: '#1F2937', accent: '#4A6CF7', name: '화이트'},
  {bg: '#0F172A', fg: '#F1F5F9', accent: '#818CF8', name: '다크'},
  {bg: 'linear-gradient(135deg, #FDE68A 0%, #FCA5A5 100%)', fg: '#7C2D12', accent: '#9A3412', name: '선셋'},
  {bg: 'linear-gradient(135deg, #A7F3D0 0%, #6EE7B7 100%)', fg: '#064E3B', accent: '#047857', name: '민트'},
  {bg: 'linear-gradient(135deg, #DBEAFE 0%, #93C5FD 100%)', fg: '#1E3A8A', accent: '#1D4ED8', name: '오션'},
  {bg: 'linear-gradient(135deg, #FCE7F3 0%, #F9A8D4 100%)', fg: '#831843', accent: '#BE185D', name: '핑크'},
  {bg: '#FAF6F1', fg: '#3F3F46', accent: '#A16207', name: '베이지'},
  {bg: '#1E1B4B', fg: '#E0E7FF', accent: '#FBBF24', name: '미드나잇'}
];

const FONT_FAMILIES = [
  {value: 'Pretendard, "Apple SD Gothic Neo", "Noto Sans KR", sans-serif', label: '프리텐다드 (기본)'},
  {value: '"Nanum Gothic", "Apple SD Gothic Neo", sans-serif', label: '나눔고딕'},
  {value: '"Nanum Myeongjo", serif', label: '나눔명조'},
  {value: '"Gowun Dodum", sans-serif', label: '고운돋움'},
  {value: 'Georgia, serif', label: 'Georgia'}
];

@inject(({teamUser}) => ({me: teamUser.me, isLogin: teamUser.isLogin}))
@inject(({review, common}) => ({
  getReviewList: review.getReviewList,
  base64UploadImages: common.base64UploadImages,
  addMyImage: common.addMyImage
}))
@observer
class ReviewToInsta extends Component {

  @observable store = {};

  // 리뷰 목록
  @observable reviews = [];
  @observable reviewsLoading = false;
  @observable reviewsPage = 1;
  @observable reviewsTotalPages = 1;
  @observable reviewsKeyword = '';
  @observable reviewsMinStar = 4;
  @observable photoOnly = false;

  // 선택된 리뷰
  @observable selectedReview = null;

  // 다중 리뷰 모드
  @observable multiMode = false;
  @observable selectedReviewIds = [];     // 다중 선택 ID 목록 (순서 유지)
  @observable multiReviewCache = {};      // ID → review 매핑 (페이지 이동시 유지)
  @observable multiLayout = '2x2';        // '1x1' / '2x1' / '1x2' / '1x3' / '2x2' / '2x3' / '3x2'

  // 피드(슬라이드) 다중 출력 — IG 캐러셀
  @observable feedCount = 1;              // 1~10
  @observable currentFeedIdx = 0;
  @observable feedReviews = {};           // 단일 모드: {feedIdx: review} — 피드별 리뷰
  @observable paginationStyle = 'none';   // none / dots / numbers / fraction (기본값 none — 표시 안 함)

  // 디자인 설정
  @observable ratioVal = '1:1';
  @observable template = 'quote';
  @observable presetIdx = 0;
  @observable bgColor = PRESET_BG[0].bg;
  @observable fgColor = PRESET_BG[0].fg;
  @observable accentColor = PRESET_BG[0].accent;
  @observable fontFamily = FONT_FAMILIES[0].value;
  @observable fontSizeScale = 1.0;       // 0.8 ~ 1.4
  @observable showText = true;            // 본문
  @observable showStars = true;
  @observable showName = true;
  @observable showProduct = true;         // 상품명
  @observable showProductImage = false;   // 상품 이미지
  @observable showReviewImages = false;   // 리뷰 이미지(개수 별도)
  @observable reviewImageCount = 4;       // 1, 2, 4 그리드
  @observable showLogo = true;
  @observable customLogo = '';
  @observable maxChars = 180;             // 본문 글자수 자르기

  // === 자유 배치 (드래그 앤 드롭) ===
  @observable elements = [];        // [{id, type, x, y, w, h}] — canvas 픽셀 좌표
  @observable selectedId = null;
  _dragState = null;                // {id, mode: 'move'|'resize-{nesw}', startX, startY, origX, origY, origW, origH}

  // === 사용자 추가 콘텐츠 (텍스트/이미지) ===
  @observable showImagePicker = false;
  @observable pickerImages = [];
  @observable pickerLoading = false;
  @observable pickerKeyword = '';
  @observable replacingElementId = null;  // 이미지 교체 모드 (null이면 새로 추가)

  // 비동기 이미지 캐시 (review images / product image)
  _imgCache = {};

  // 출력
  @observable isExporting = false;

  // 캔버스 줌 (1 = 영역 fit, 2 = 200%)
  @observable zoom = 1;
  @observable areaW = 0;
  @observable areaH = 0;

  canvasRef = React.createRef();
  areaRef = React.createRef();
  searchTimer = null;
  resizeObs = null;

  componentDidMount() {
    if (this.props.me) {
      this.store = this.props.me.store ? this.props.me.store : {};
    }
    this.loadReviews();
    this.setupResizeObserver();
    this.resetLayout();
  }

  componentWillUnmount() {
    if (this.resizeObs) { this.resizeObs.disconnect(); this.resizeObs = null; }
  }

  componentDidUpdate() {
    // 설정 변경시 캔버스 자동 갱신
    this.drawCanvas();
    // areaRef가 늦게 마운트된 경우 (selectedReview 가 늦게 set) 옵저버 재연결
    if (this.areaRef.current && !this.resizeObs) this.setupResizeObserver();
  }

  setupResizeObserver = () => {
    if (typeof ResizeObserver === 'undefined') return;
    if (!this.areaRef.current) return;
    this.resizeObs = new ResizeObserver(entries => {
      for (const e of entries) {
        this.areaW = e.contentRect.width;
        this.areaH = e.contentRect.height;
      }
    });
    this.resizeObs.observe(this.areaRef.current);
  };

  @computed get fitSize() {
    const r = this.currentRatio;
    if (!this.areaW || !this.areaH) return {w: 0, h: 0};
    const ar = r.w / r.h;
    let w = this.areaW;
    let h = w / ar;
    if (h > this.areaH) { h = this.areaH; w = h * ar; }
    return {w, h};
  }

  @computed get displaySize() {
    const f = this.fitSize;
    return {w: f.w * this.zoom, h: f.h * this.zoom};
  }

  @action zoomIn = () => { this.zoom = Math.min(4, Math.round((this.zoom + 0.25) * 100) / 100); };
  @action zoomOut = () => { this.zoom = Math.max(0.25, Math.round((this.zoom - 0.25) * 100) / 100); };
  @action zoomFit = () => { this.zoom = 1; };
  @action onWheel = (e) => {
    if (!e.ctrlKey && !e.metaKey) return;
    e.preventDefault();
    if (e.deltaY < 0) this.zoomIn();
    else this.zoomOut();
  };

  @computed get hasStore() { return !!(this.store && this.store._id); }
  @computed get currentRatio() { return RATIOS.find(r => r.value === this.ratioVal) || RATIOS[0]; }

  // === 리뷰 로드 ===
  @action loadReviews = async () => {
    if (!this.hasStore) return;
    this.reviewsLoading = true;
    try {
      const params = {
        store_id: this.store._id,
        shopNo: this.store.shopNo || 1,
        limit: 30,
        page: this.reviewsPage,
        sort: 'createdAt',
        searchParams: {
          displayAt: 'all',
          star: {
            all: this.reviewsMinStar === 0,
            star1: this.reviewsMinStar === 0,
            star2: this.reviewsMinStar === 0,
            star3: this.reviewsMinStar <= 3,
            star4: this.reviewsMinStar <= 4,
            star5: this.reviewsMinStar <= 5
          }
        }
      };
      if (this.photoOnly) params.reviewType = 'media';
      if (this.reviewsKeyword) {
        params.searchParams.keyword = this.reviewsKeyword;
        params.searchParams.searchType = '';
      }
      const res = await this.props.getReviewList(params);
      if (res && Array.isArray(res.docs)) {
        this.reviews = res.docs;
        this.reviewsTotalPages = res.totalPages || 1;
        if (!this.selectedReview && this.reviews.length > 0) {
          this.selectReview(this.reviews[0]);
        }
      }
    } catch (e) {
      toast.error('리뷰를 불러오지 못했습니다.');
    } finally {
      this.reviewsLoading = false;
    }
  };

  @action selectReview = (r) => {
    if (this.multiMode) {
      this.toggleMultiSelect(r);
    } else {
      this.selectedReview = r;
      // 피드별 리뷰 저장
      this.feedReviews[this.currentFeedIdx] = r;
    }
  };

  // 다중 모드의 셀 수 (current layout)
  @computed get cellsPerFeed() { return this.maxCellsForLayout(); }

  // 현재 피드에 표시할 리뷰들
  @computed get effectiveReviews() {
    if (this.multiMode) {
      const map = {...this.multiReviewCache};
      this.reviews.forEach(rv => { if (!map[rv._id]) map[rv._id] = rv; });
      const all = this.selectedReviewIds.map(id => map[id]).filter(Boolean);
      // 피드별로 cellsPerFeed 만큼 슬라이스
      const start = this.currentFeedIdx * this.cellsPerFeed;
      return all.slice(start, start + this.cellsPerFeed);
    }
    // 단일 모드: 현재 피드에 할당된 리뷰 (없으면 selectedReview 폴백)
    const r = this.feedReviews[this.currentFeedIdx];
    return r ? [r] : (this.selectedReview ? [this.selectedReview] : []);
  }

  // 단일 모드에서 현재 피드의 리뷰 가져오기
  @computed get currentFeedReview() {
    return this.feedReviews[this.currentFeedIdx] || this.selectedReview;
  }

  @action setFeedCount = (n) => {
    this.feedCount = Math.max(1, Math.min(10, parseInt(n, 10) || 1));
    if (this.currentFeedIdx >= this.feedCount) this.currentFeedIdx = this.feedCount - 1;
    this.resetLayout();
  };

  @action setCurrentFeed = (idx) => {
    if (idx < 0 || idx >= this.feedCount) return;
    this.currentFeedIdx = idx;
    // 단일 모드에서 selectedReview를 해당 피드의 리뷰로 동기화 (있으면)
    if (!this.multiMode && this.feedReviews[idx]) {
      this.selectedReview = this.feedReviews[idx];
    }
  };

  @action prevFeed = () => this.setCurrentFeed(this.currentFeedIdx - 1);
  @action nextFeed = () => this.setCurrentFeed(this.currentFeedIdx + 1);

  @action toggleMultiMode = () => {
    this.multiMode = !this.multiMode;
    if (this.multiMode) {
      // 단일 모드에서 선택된 리뷰가 있으면 다중 선택의 첫 항목으로
      if (this.selectedReview && !this.selectedReviewIds.includes(this.selectedReview._id)) {
        this.selectedReviewIds = [this.selectedReview._id];
      }
    }
    this.resetLayout();
  };

  @action toggleMultiSelect = (r) => {
    // 캐시에 항상 등록 (해제해도 페이지 이동시 다시 선택 가능)
    this.multiReviewCache[r._id] = r;
    if (this.selectedReviewIds.includes(r._id)) {
      this.selectedReviewIds = this.selectedReviewIds.filter(x => x !== r._id);
    } else {
      const max = this.maxCellsForLayout();
      if (this.selectedReviewIds.length >= max) {
        this.selectedReviewIds = [...this.selectedReviewIds.slice(1), r._id];
      } else {
        this.selectedReviewIds = [...this.selectedReviewIds, r._id];
      }
    }
    this.resetLayout();
  };

  maxCellsForLayout = () => {
    const map = {'1x1': 1, '2x1': 2, '1x2': 2, '1x3': 3, '3x1': 3, '2x2': 4, '2x3': 6, '3x2': 6};
    return map[this.multiLayout] || 4;
  };

  @action setMultiLayout = (v) => { this.multiLayout = v; this.resetLayout(); };

  @action onKeywordChange = (e) => {
    this.reviewsKeyword = e.target.value;
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => { this.reviewsPage = 1; this.loadReviews(); }, 300);
  };

  @action setMinStar = (n) => { this.reviewsMinStar = n; this.reviewsPage = 1; this.loadReviews(); };
  @action togglePhotoOnly = () => { this.photoOnly = !this.photoOnly; this.reviewsPage = 1; this.loadReviews(); };
  @action goReviewsPage = (p) => { if (p < 1 || p > this.reviewsTotalPages) return; this.reviewsPage = p; this.loadReviews(); };

  // === 디자인 설정 ===
  @action setRatio = (v) => { this.ratioVal = v; this.resetLayout(); };
  @action setTemplate = (v) => { this.template = v; this.resetLayout(); };

  // === 자유 배치: 기본 레이아웃 생성 ===
  @action resetLayout = () => {
    const r = this.currentRatio;
    const W = r.w, H = r.h;
    const pad = W * 0.08;
    const innerW = W - pad * 2;

    // 다중 리뷰 모드: 셀 그리드
    if (this.multiMode) {
      const [cols, rows] = this.multiLayout.split('x').map(n => parseInt(n, 10));
      const gap = W * 0.025;
      const gridX = pad, gridY = pad;
      const gridW = W - pad * 2;
      const gridH = H - pad * 2;
      const cellW = (gridW - gap * (cols - 1)) / cols;
      const cellH = (gridH - gap * (rows - 1)) / rows;
      const els = [];
      for (let i = 0; i < cols * rows; i++) {
        const cx = i % cols;
        const cy = Math.floor(i / cols);
        els.push({
          id: `cell-${i}`,
          type: 'multiCell',
          reviewIdx: i,
          x: gridX + cx * (cellW + gap),
          y: gridY + cy * (cellH + gap),
          w: cellW, h: cellH,
          label: `리뷰 ${i + 1}`
        });
      }
      // 로고는 항상 추가
      els.push({id: 'logo', type: 'logo', x: W - pad - W * 0.25, y: H - pad * 0.6, w: W * 0.25, h: W * 0.03, label: '핸들/로고'});
      // 페이지네이션 (피드 1개 초과시 표시)
      els.push({id: 'pagination', type: 'pagination',
        x: W * 0.2, y: H - pad * 0.5, w: W * 0.6, h: W * 0.04,
        label: '페이지네이션'});
      this.elements = els;
      this.selectedId = null;
      return;
    }

    const labels = {
      reviewImages: '리뷰 이미지',
      text:    '본문 텍스트',
      stars:   '별점',
      name:    '작성자',
      product: '상품 정보',
      logo:    '핸들/로고',
      quote:   '큰 따옴표',
      accent:  '액센트 라인'
    };
    let els = [];
    const push = (e) => els.push({...e, label: labels[e.type] || e.type});

    // 템플릿별 기본 배치
    if (this.template === 'quote') {
      push({id: 'quote',   type: 'quote',   x: pad, y: pad * 0.4, w: W * 0.18, h: W * 0.18});
      push({id: 'reviewImages', type: 'reviewImages', x: pad, y: pad,                w: innerW, h: H * 0.32});
      push({id: 'text',    type: 'text',    x: pad, y: H * 0.30,                    w: innerW, h: H * 0.40});
      push({id: 'product', type: 'product', x: pad, y: H - pad - W * 0.4,           w: innerW, h: W * 0.13});
      push({id: 'stars',   type: 'stars',   x: pad, y: H - pad - W * 0.18,          w: W * 0.25, h: W * 0.04});
      push({id: 'name',    type: 'name',    x: pad, y: H - pad - W * 0.07,          w: W * 0.5,  h: W * 0.04});
      push({id: 'logo',    type: 'logo',    x: W - pad - W * 0.25, y: H - pad * 0.6, w: W * 0.25, h: W * 0.03});
    } else if (this.template === 'card') {
      const cardX = pad, cardY = pad * 0.7, cardW = W - pad * 2, cardH = H - cardY - pad * 1.4;
      const ip = pad * 0.7;
      const inLeft = cardX + ip;
      const inW = cardW - ip * 2;
      const inTop = cardY + ip;
      const inBot = cardY + cardH - ip;
      const gap = ip * 0.4;
      const starsH = W * 0.038;
      const nameH = W * 0.04;
      const productH = W * 0.13;
      const imgH = cardH * 0.32;
      // 위 누적
      let topY = inTop;
      push({id: 'reviewImages', type: 'reviewImages', x: inLeft, y: topY, w: inW, h: imgH});
      topY += imgH + gap;
      push({id: 'stars', type: 'stars', x: inLeft, y: topY, w: W * 0.25, h: starsH});
      topY += starsH + gap;
      // 아래 누적
      let botY = inBot;
      botY -= nameH;
      push({id: 'name', type: 'name', x: inLeft, y: botY, w: W * 0.5, h: nameH});
      botY -= gap;
      botY -= productH;
      push({id: 'product', type: 'product', x: inLeft, y: botY, w: inW, h: productH});
      botY -= gap;
      // 본문 (남는 영역)
      push({id: 'text', type: 'text', x: inLeft, y: topY, w: inW, h: Math.max(60, botY - topY)});
      push({id: 'logo', type: 'logo', x: W - pad - W * 0.25, y: H - pad * 0.6, w: W * 0.25, h: W * 0.03});
    } else if (this.template === 'photo') {
      const gap = pad * 0.4;
      const photoH = H * 0.5;
      const starsH = W * 0.045;
      const nameH = W * 0.04;
      const productH = W * 0.13;
      push({id: 'reviewImages', type: 'reviewImages', x: 0, y: 0, w: W, h: photoH});
      // 위 누적 (사진 아래)
      let topY = photoH + gap;
      push({id: 'stars', type: 'stars', x: pad, y: topY, w: W * 0.25, h: starsH});
      topY += starsH + gap;
      // 아래 누적
      let botY = H - pad * 0.7;
      botY -= nameH;
      push({id: 'name', type: 'name', x: pad, y: botY, w: W * 0.5, h: nameH});
      botY -= gap;
      botY -= productH;
      push({id: 'product', type: 'product', x: pad, y: botY, w: innerW, h: productH});
      botY -= gap;
      push({id: 'text', type: 'text', x: pad, y: topY, w: innerW, h: Math.max(60, botY - topY)});
      push({id: 'logo', type: 'logo', x: W - pad - W * 0.25, y: H - pad * 0.6, w: W * 0.25, h: W * 0.03});
    } else { // minimal
      const gap = pad * 0.4;
      const imgH = H * 0.26;
      const starsH = W * 0.035;
      const nameH = W * 0.04;
      const productH = W * 0.12;
      const accentH = 6;
      // 위
      let topY = pad;
      push({id: 'reviewImages', type: 'reviewImages', x: pad, y: topY, w: innerW, h: imgH});
      topY += imgH + gap;
      // 아래 누적
      let botY = H - pad * 0.7;
      botY -= nameH;
      push({id: 'name', type: 'name', x: pad, y: botY, w: W * 0.5, h: nameH});
      botY -= gap * 0.5;
      botY -= starsH;
      push({id: 'stars', type: 'stars', x: pad, y: botY, w: W * 0.25, h: starsH});
      botY -= gap * 0.5;
      botY -= accentH;
      push({id: 'accent', type: 'accent', x: pad, y: botY, w: W * 0.12, h: accentH});
      botY -= gap;
      botY -= productH;
      push({id: 'product', type: 'product', x: pad, y: botY, w: innerW, h: productH});
      botY -= gap;
      push({id: 'text', type: 'text', x: pad, y: topY, w: innerW, h: Math.max(60, botY - topY)});
      push({id: 'logo', type: 'logo', x: W - pad - W * 0.25, y: H - pad * 0.6, w: W * 0.25, h: W * 0.03});
    }
    // 페이지네이션 (피드 1개 초과시 표시)
    push({id: 'pagination', type: 'pagination',
      x: W * 0.2, y: H - pad * 0.5, w: W * 0.6, h: W * 0.04});
    this.elements = els;
    this.selectedId = null;
  };

  isElementVisible = (el) => {
    switch (el.type) {
      case 'reviewImages': return this.showReviewImages;
      case 'text':    return this.showText;
      case 'stars':   return this.showStars;
      case 'name':    return this.showName;
      case 'product': return this.showProductImage || (this.showProduct && !!this.getProductName(this.selectedReview));
      case 'logo':    return this.showLogo;
      case 'quote':   return this.template === 'quote' && this.showText;
      case 'accent':  return this.template === 'minimal';
      case 'multiCell': return this.multiMode && el.reviewIdx < this.effectiveReviews.length;
      case 'pagination': return this.feedCount > 1 && this.paginationStyle !== 'none';
      case 'customText':
      case 'customImage': return true;
      default: return true;
    }
  };

  // === 드래그/리사이즈 ===
  @action selectElement = (id) => { this.selectedId = id; };
  @action deselectElement = () => { this.selectedId = null; };

  startDrag = (e, el, mode) => {
    e.preventDefault();
    e.stopPropagation();
    this.selectElement(el.id);
    this._dragState = {
      id: el.id, mode,
      startX: e.clientX, startY: e.clientY,
      origX: el.x, origY: el.y, origW: el.w, origH: el.h
    };
    window.addEventListener('mousemove', this.onDragMove);
    window.addEventListener('mouseup', this.onDragEnd);
  };

  onDragMove = (e) => {
    if (!this._dragState) return;
    const ds = this._dragState;
    const r = this.currentRatio;
    const scale = this.displaySize.w ? (r.w / this.displaySize.w) : 1;
    const dx = (e.clientX - ds.startX) * scale;
    const dy = (e.clientY - ds.startY) * scale;
    const el = this.elements.find(x => x.id === ds.id);
    if (!el) return;
    if (ds.mode === 'move') {
      el.x = Math.max(0, Math.min(r.w - el.w, ds.origX + dx));
      el.y = Math.max(0, Math.min(r.h - el.h, ds.origY + dy));
    } else if (ds.mode === 'resize-se') {
      el.w = Math.max(40, Math.min(r.w - el.x, ds.origW + dx));
      el.h = Math.max(20, Math.min(r.h - el.y, ds.origH + dy));
    } else if (ds.mode === 'resize-sw') {
      const newW = Math.max(40, ds.origW - dx);
      el.x = Math.max(0, Math.min(ds.origX + ds.origW - 40, ds.origX + dx));
      el.w = newW;
      el.h = Math.max(20, Math.min(r.h - el.y, ds.origH + dy));
    } else if (ds.mode === 'resize-ne') {
      const newH = Math.max(20, ds.origH - dy);
      el.y = Math.max(0, Math.min(ds.origY + ds.origH - 20, ds.origY + dy));
      el.h = newH;
      el.w = Math.max(40, Math.min(r.w - el.x, ds.origW + dx));
    } else if (ds.mode === 'resize-nw') {
      const newW = Math.max(40, ds.origW - dx);
      const newH = Math.max(20, ds.origH - dy);
      el.x = Math.max(0, Math.min(ds.origX + ds.origW - 40, ds.origX + dx));
      el.y = Math.max(0, Math.min(ds.origY + ds.origH - 20, ds.origY + dy));
      el.w = newW;
      el.h = newH;
    }
  };

  onDragEnd = () => {
    this._dragState = null;
    window.removeEventListener('mousemove', this.onDragMove);
    window.removeEventListener('mouseup', this.onDragEnd);
  };

  // === 사용자 콘텐츠 추가/편집/삭제 ===
  @action addCustomText = () => {
    const r = this.currentRatio;
    const id = `custom-text-${Date.now()}`;
    this.elements.push({
      id, type: 'customText',
      x: r.w / 2 - r.w * 0.2,
      y: r.h / 2 - r.h * 0.04,
      w: r.w * 0.4,
      h: r.w * 0.08,
      content: '텍스트를 입력하세요',
      fontSize: r.w * 0.04,
      color: this.fgColor,
      weight: '600',
      align: 'center',
      label: '텍스트'
    });
    this.selectedId = id;
  };

  @action openCustomImagePicker = () => {
    this.replacingElementId = null;
    this.showImagePicker = true;
    this.loadPickerImages();
  };

  @action openReplaceImage = (elemId) => {
    this.replacingElementId = elemId;
    this.showImagePicker = true;
    this.loadPickerImages();
  };

  @action closeImagePicker = () => {
    this.showImagePicker = false;
    this.replacingElementId = null;
    this.pickerKeyword = '';
  };

  @action loadPickerImages = async () => {
    if (!this.hasStore) return;
    this.pickerLoading = true;
    try {
      const res = await this.props.getMyImageList({
        store_id: this.store._id,
        shopNo: this.store.shopNo || 1,
        page: 1, limit: 60,
        keyword: this.pickerKeyword || ''
      });
      this.pickerImages = (res && res.data && res.data.docs) ? res.data.docs : [];
    } catch (e) {} finally { this.pickerLoading = false; }
  };

  @action onPickerKwChange = (e) => {
    this.pickerKeyword = e.target.value;
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.loadPickerImages(), 300);
  };

  @action selectImageForCustom = (img) => {
    if (this.replacingElementId) {
      const el = this.elements.find(e => e.id === this.replacingElementId);
      if (el) el.imageUrl = img.url;
    } else {
      const r = this.currentRatio;
      const id = `custom-img-${Date.now()}`;
      const aspect = (img.width && img.height) ? img.width / img.height : 1;
      let w = r.w * 0.35, h = w / aspect;
      if (h > r.h * 0.4) { h = r.h * 0.4; w = h * aspect; }
      this.elements.push({
        id, type: 'customImage',
        x: r.w / 2 - w / 2,
        y: r.h / 2 - h / 2,
        w, h,
        imageUrl: img.url,
        label: '이미지'
      });
      this.selectedId = id;
    }
    this.closeImagePicker();
  };

  @action deleteSelected = () => {
    if (!this.selectedId) return;
    const el = this.elements.find(e => e.id === this.selectedId);
    if (!el) return;
    if (!String(el.id).startsWith('custom-')) {
      toast.error('기본 요소는 좌측 토글로 끄세요.');
      return;
    }
    this.elements = this.elements.filter(e => e.id !== this.selectedId);
    this.selectedId = null;
  };

  @action editTextPrompt = (el) => {
    const newText = window.prompt('텍스트 입력:', el.content || '');
    if (newText === null) return;
    el.content = newText;
  };

  @computed get selectedElement() {
    return this.selectedId ? this.elements.find(e => e.id === this.selectedId) : null;
  }
  isCustomElement = (el) => el && String(el.id).startsWith('custom-');
  @action setPreset = (idx) => {
    this.presetIdx = idx;
    const p = PRESET_BG[idx];
    this.bgColor = p.bg;
    this.fgColor = p.fg;
    this.accentColor = p.accent;
  };

  // === 캔버스 그리기 — element 기반 (자유 배치) ===
  drawCanvas = () => {
    const canvas = this.canvasRef.current;
    if (!canvas) return;
    // 그릴 리뷰가 하나도 없으면 스킵
    if (this.multiMode) {
      if (this.effectiveReviews.length === 0) return;
    } else if (!this.selectedReview) return;
    const r = this.currentRatio;
    canvas.width = r.w;
    canvas.height = r.h;
    const ctx = canvas.getContext('2d');

    // 배경
    this.drawBackground(ctx, canvas);

    // 카드 템플릿: 배경 위에 카드 박스 (배경 데코 역할) — 다중 모드에선 셀별로 카드가 그려지므로 스킵
    if (this.template === 'card' && !this.multiMode) {
      const pad = r.w * 0.08;
      const cardX = pad, cardY = pad * 0.7;
      const cardW = r.w - pad * 2;
      const cardH = r.h - cardY - pad * 1.4;
      ctx.fillStyle = this.bgColor.startsWith('linear-gradient') ? '#FFFFFF' : this.lighten(this.bgColor, 8);
      this.roundRect(ctx, cardX, cardY, cardW, cardH, r.w * 0.03);
      ctx.fill();
    }

    // z-order 정렬: 이미지 요소(reviewImages / multiCell)는 항상 최하단으로
    const sorted = this.sortedElements();
    sorted.forEach(el => {
      if (!this.isElementVisible(el)) return;
      this.drawElement(ctx, el);
    });
  };

  // 이미지 타입은 z-index 가장 낮게(맨 먼저 그림 → 뒷면)
  IMAGE_TYPES = new Set(['reviewImages', 'multiCell', 'customImage']);
  sortedElements = () => {
    const imgs = [], others = [];
    this.elements.forEach(el => (this.IMAGE_TYPES.has(el.type) ? imgs : others).push(el));
    return [...imgs, ...others];
  };

  drawElement = (ctx, el) => {
    const r = this.currentRatio;
    // multiCell 은 효율적으로 처리 후 종료
    if (el.type === 'multiCell') {
      const rv = this.effectiveReviews[el.reviewIdx];
      if (rv) this.drawMiniReview(ctx, el.x, el.y, el.w, el.h, rv);
      return;
    }
    if (el.type === 'pagination') {
      this.drawPagination(ctx, el);
      return;
    }
    if (el.type === 'customText') {
      const fs = el.fontSize || r.w * 0.04;
      this.drawTextInRect(ctx, el.content || '', el.x, el.y, el.w, el.h,
        {weight: el.weight || '600', fontSize: fs, lineHeight: 1.3,
         color: el.color || this.fgColor, valign: 'middle', align: el.align || 'center'});
      return;
    }
    if (el.type === 'customImage') {
      const img = this.loadImage(el.imageUrl);
      if (img) {
        ctx.save();
        this.roundRect(ctx, el.x, el.y, el.w, el.h, 4);
        ctx.clip();
        this.drawImageCover(ctx, img, el.x, el.y, el.w, el.h);
        ctx.restore();
      } else {
        this.drawImagePlaceholder(ctx, el.x, el.y, el.w, el.h, '이미지 로딩…');
      }
      return;
    }
    const review = this.multiMode
      ? (this.effectiveReviews[0] || this.selectedReview)
      : (this.feedReviews[this.currentFeedIdx] || this.selectedReview);
    if (!review) return;
    switch (el.type) {
      case 'reviewImages':
        this.drawReviewImagesGrid(ctx, el.x, el.y, el.w, el.h, this.getReviewImageUrls(review), this.reviewImageCount);
        break;
      case 'text': {
        const fs = (this.template === 'minimal' ? r.w * 0.05 : r.w * 0.04) * this.fontSizeScale;
        this.drawTextInRect(ctx, this.truncate(this.cleanText(review.contents), this.maxChars),
          el.x, el.y, el.w, el.h,
          {weight: this.template === 'minimal' ? '300' : '500', fontSize: fs, lineHeight: 1.5,
           color: this.fgColor, valign: this.template === 'minimal' ? 'middle' : 'top'});
        break;
      }
      case 'stars': {
        const starSize = Math.min(el.h, el.w / 5);
        this.drawStars(ctx, el.x, el.y + el.h / 2 - 1, starSize, review.goodsPt || 5, this.accentColor, this.hexAlpha(this.fgColor, 0.18));
        break;
      }
      case 'name': {
        ctx.fillStyle = this.hexAlpha(this.fgColor, 0.7);
        const fs = Math.min(el.h * 0.7, r.w * 0.028);
        ctx.font = `500 ${fs}px ${this.fontFamily}`;
        ctx.textBaseline = 'middle';
        const txt = `${this.maskName(review.writerName || '고객')} 님`;
        ctx.fillText(txt, el.x, el.y + el.h / 2);
        ctx.textBaseline = 'top';
        break;
      }
      case 'product':
        this.drawProductInfo(ctx, el.x, el.y, el.w, el.h, review);
        break;
      case 'quote': {
        ctx.fillStyle = this.accentColor;
        const fs = Math.min(el.h, el.w);
        ctx.font = `bold ${fs}px ${this.fontFamily}`;
        ctx.textBaseline = 'top';
        ctx.fillText('“', el.x, el.y);
        break;
      }
      case 'accent':
        ctx.strokeStyle = this.accentColor;
        ctx.lineWidth = el.h;
        ctx.beginPath();
        ctx.moveTo(el.x, el.y + el.h / 2);
        ctx.lineTo(el.x + el.w, el.y + el.h / 2);
        ctx.stroke();
        break;
      case 'logo': {
        const label = this.customLogo || (this.store && this.store.name) || '';
        if (!label) return;
        ctx.fillStyle = this.hexAlpha(this.fgColor, 0.45);
        const fs = Math.min(el.h, r.w * 0.025);
        ctx.font = `600 ${fs}px ${this.fontFamily}`;
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'right';
        ctx.fillText('@' + label, el.x + el.w, el.y + el.h / 2);
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        break;
      }
      default: break;
    }
  };

  drawBackground = (ctx, canvas) => {
    if (this.bgColor.startsWith('linear-gradient')) {
      // 단순 파싱: linear-gradient(135deg, #aaa 0%, #bbb 100%)
      const m = this.bgColor.match(/linear-gradient\(([^,]+),\s*(#[0-9a-fA-F]+|[a-z]+)[^,]*,\s*(#[0-9a-fA-F]+|[a-z]+)/);
      if (m) {
        const grad = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        grad.addColorStop(0, m[2]);
        grad.addColorStop(1, m[3]);
        ctx.fillStyle = grad;
      } else {
        ctx.fillStyle = '#FFFFFF';
      }
    } else {
      ctx.fillStyle = this.bgColor;
    }
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  };

  cleanText = (s) => {
    if (!s) return '';
    return String(s).replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
  };

  // 리뷰의 이미지 URL 목록 추출 — thumbs/images/platformImages 다양한 포맷 대응
  getReviewImageUrls = (rv) => {
    if (!rv) return [];
    const out = [];
    const push = (item) => {
      if (!item) return;
      if (typeof item === 'string') out.push(item);
      else if (item.url) out.push(item.url);
      else if (item.path) out.push(item.path);
    };
    if (Array.isArray(rv.thumbs)) rv.thumbs.forEach(push);
    if (out.length === 0 && Array.isArray(rv.images)) rv.images.forEach(push);
    if (out.length === 0 && Array.isArray(rv.platformImages)) rv.platformImages.forEach(push);
    return out.filter(Boolean);
  };

  // 상품 이미지 URL 추출 — getReviewList 가 product_id 를 populate(image, productName) 함
  getProductImageUrl = (rv) => {
    if (!rv) return '';
    // 1순위: populated product_id
    if (rv.product_id && typeof rv.product_id === 'object') {
      if (rv.product_id.image)  return rv.product_id.image;
      if (rv.product_id.imgUrl) return rv.product_id.imgUrl;
      if (rv.product_id.thumb)  return rv.product_id.thumb;
    }
    // 2순위: 별도로 가공된 product 필드
    if (rv.product && typeof rv.product === 'object') {
      if (rv.product.image)  return rv.product.image;
      if (rv.product.imgUrl) return rv.product.imgUrl;
      if (rv.product.thumb)  return rv.product.thumb;
    }
    return '';
  };

  getProductName = (rv) => {
    if (!rv) return '';
    if (rv.orderProductName) return rv.orderProductName;
    if (rv.product_id && typeof rv.product_id === 'object' && rv.product_id.productName) return rv.product_id.productName;
    if (rv.product && rv.product.productName) return rv.product.productName;
    return '';
  };

  // CORS 우회용 — 외부 도메인 이미지는 백엔드 프록시 경유, 동일 도메인은 직접
  proxyUrl = (url) => {
    if (!url) return url;
    try {
      const u = new URL(url, window.location.origin);
      if (u.origin === window.location.origin) return url;
      const apiBase = process.env.NODE_ENV === 'development'
        ? 'https://orpapi.onreview.co.kr'
        : 'https://orpapi.onreview.co.kr';
      return `${apiBase}/api/img-proxy?url=${encodeURIComponent(url)}`;
    } catch (e) { return url; }
  };

  // 비동기 이미지 로딩 + 캐시. 처음 호출시 null 반환 + onload 후 drawCanvas 재호출
  loadImage = (url) => {
    if (!url) return null;
    if (this._imgCache[url] === 'loading') return null;
    if (this._imgCache[url] === 'error') return null;
    if (this._imgCache[url]) return this._imgCache[url];
    this._imgCache[url] = 'loading';
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => { this._imgCache[url] = img; this.drawCanvas(); };
    img.onerror = () => {
      // 1차 실패 → 프록시 경유로 재시도
      const proxied = this.proxyUrl(url);
      if (proxied !== url) {
        const retry = new Image();
        retry.crossOrigin = 'anonymous';
        retry.onload = () => { this._imgCache[url] = retry; this.drawCanvas(); };
        retry.onerror = () => { this._imgCache[url] = 'error'; };
        retry.src = proxied;
      } else {
        this._imgCache[url] = 'error';
      }
    };
    // 외부 도메인이면 처음부터 프록시 경유 (rate limit / 빠른 응답)
    img.src = this.proxyUrl(url);
  };

  // 이미지 cover 그리기 (object-fit: cover 효과)
  drawImageCover = (ctx, img, dx, dy, dw, dh) => {
    const ar = img.width / img.height;
    const target = dw / dh;
    let sx = 0, sy = 0, sw = img.width, sh = img.height;
    if (ar > target) { sw = img.height * target; sx = (img.width - sw) / 2; }
    else { sh = img.width / target; sy = (img.height - sh) / 2; }
    ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
  };

  // 이미지 영역 placeholder
  drawImagePlaceholder = (ctx, x, y, w, h, label) => {
    ctx.fillStyle = this.hexAlpha(this.fgColor, 0.06);
    ctx.fillRect(x, y, w, h);
    // label 이 빈 문자열/null/undefined 면 텍스트를 그리지 않음 (placeholder 배경만 노출)
    if (label) {
      ctx.fillStyle = this.hexAlpha(this.fgColor, 0.35);
      ctx.font = `500 ${Math.max(12, w * 0.025)}px ${this.fontFamily}`;
      const prevAlign = ctx.textAlign, prevBase = ctx.textBaseline;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(label, x + w / 2, y + h / 2);
      ctx.textAlign = prevAlign;
      ctx.textBaseline = prevBase;
    }
  };

  truncate = (s, n) => {
    if (!s) return '';
    return s.length > n ? s.slice(0, n) + '…' : s;
  };

  // 사각 영역에 들어가는 만큼만 텍스트 그리기 (높이 초과시 마지막 줄에 ellipsis)
  drawTextInRect = (ctx, text, x, y, w, h, opts) => {
    if (!text || h <= 0 || w <= 0) return 0;
    const o = opts || {};
    const weight = o.weight || '500';
    const fontSize = o.fontSize || 16;
    const lineHeightMul = o.lineHeight || 1.5;
    const color = o.color || this.fgColor;
    const valign = o.valign || 'top';
    const align = o.align || 'left';

    ctx.fillStyle = color;
    ctx.font = `${weight} ${fontSize}px ${this.fontFamily}`;
    ctx.textBaseline = 'top';
    const prevAlign = ctx.textAlign;
    ctx.textAlign = align;
    const ax = align === 'center' ? x + w / 2 : (align === 'right' ? x + w : x);

    const lh = fontSize * lineHeightMul;
    const lines = this.wrapText(ctx, text, w);
    const maxLines = Math.max(1, Math.floor(h / lh));
    let visible = lines.slice(0, maxLines);
    if (lines.length > maxLines) {
      let last = visible[visible.length - 1];
      while (last && ctx.measureText(last + '…').width > w && last.length > 1) {
        last = last.slice(0, -1);
      }
      visible[visible.length - 1] = (last || '') + '…';
    }
    const totalH = visible.length * lh;
    let drawY = y;
    if (valign === 'middle') drawY = y + Math.max(0, (h - totalH) / 2);
    else if (valign === 'bottom') drawY = y + Math.max(0, h - totalH);
    visible.forEach(line => { ctx.fillText(line, ax, drawY); drawY += lh; });
    ctx.textAlign = prevAlign;
    return totalH;
  };

  wrapText = (ctx, text, maxWidth) => {
    const words = text.split('');
    const lines = [];
    let line = '';
    for (let i = 0; i < words.length; i++) {
      const test = line + words[i];
      if (ctx.measureText(test).width > maxWidth && line) {
        lines.push(line);
        line = words[i];
      } else {
        line = test;
      }
    }
    if (line) lines.push(line);
    return lines;
  };

  // === 피드 페이지네이션 그리기 ===
  drawPagination = (ctx, el) => {
    if (this.feedCount <= 1) return;
    const cur = this.currentFeedIdx;
    const total = this.feedCount;
    if (this.paginationStyle === 'fraction') {
      ctx.fillStyle = this.fgColor;
      const fs = Math.min(el.h * 0.6, el.w * 0.18);
      ctx.font = `700 ${fs}px ${this.fontFamily}`;
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'center';
      const txt = `${cur + 1} / ${total}`;
      // 배경 칩
      const tw = ctx.measureText(txt).width;
      const padX = fs * 0.5;
      const chipW = tw + padX * 2;
      const chipH = fs * 1.6;
      ctx.fillStyle = this.hexAlpha(this.fgColor, 0.85);
      this.roundRect(ctx, el.x + el.w / 2 - chipW / 2, el.y + el.h / 2 - chipH / 2, chipW, chipH, chipH / 2);
      ctx.fill();
      ctx.fillStyle = this.bgColor.startsWith('linear-gradient') ? '#FFFFFF' : this.bgColor;
      ctx.fillText(txt, el.x + el.w / 2, el.y + el.h / 2);
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      return;
    }
    if (this.paginationStyle === 'numbers') {
      const fs = Math.min(el.h * 0.5, el.w * 0.05);
      const gap = fs * 0.6;
      ctx.font = `600 ${fs}px ${this.fontFamily}`;
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'center';
      // 폭 측정 (총합)
      const sample = ctx.measureText('00').width;
      const totalW = total * sample + gap * (total - 1);
      let x = el.x + (el.w - totalW) / 2 + sample / 2;
      const cy = el.y + el.h / 2;
      for (let i = 0; i < total; i++) {
        const isCur = i === cur;
        ctx.fillStyle = isCur ? this.accentColor : this.hexAlpha(this.fgColor, 0.35);
        ctx.fillText(String(i + 1).padStart(2, '0'), x, cy);
        x += sample + gap;
      }
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      return;
    }
    // dots (default) — 모든 점 동일 크기, 색상으로만 활성 구분
    const dotR = Math.min(el.h * 0.35, el.w * 0.012);
    const gap = dotR * 2.2;
    const stride = dotR * 2 + gap;        // 점 간 일정 간격
    const totalW = total * (dotR * 2) + (total - 1) * gap;
    const startX = el.x + (el.w - totalW) / 2 + dotR;
    const cy = el.y + el.h / 2;
    for (let i = 0; i < total; i++) {
      const isCur = i === cur;
      const cx = startX + i * stride;
      ctx.beginPath();
      ctx.arc(cx, cy, dotR, 0, Math.PI * 2);
      ctx.fillStyle = isCur ? this.accentColor : this.hexAlpha(this.fgColor, 0.3);
      ctx.fill();
    }
  };

  // 셀 안에 미니 리뷰 카드 그리기 (다중 리뷰 모드용)
  drawMiniReview = (ctx, x, y, w, h, review) => {
    const radius = Math.min(w, h) * 0.04;
    // 배경 카드
    ctx.fillStyle = this.bgColor.startsWith('linear-gradient') ? '#FFFFFF' : this.lighten(this.bgColor, 8);
    this.roundRect(ctx, x, y, w, h, radius);
    ctx.fill();

    const inner = Math.min(w, h) * 0.06;
    const imgUrls = this.getReviewImageUrls(review);
    const hasImg = this.showReviewImages && imgUrls.length > 0;

    let topY = y + inner;
    // 상단 이미지 (있으면 셀 높이의 50%)
    if (hasImg) {
      const imgH = (h - inner * 2) * 0.55;
      ctx.save();
      this.roundRect(ctx, x + inner, topY, w - inner * 2, imgH, radius * 0.6);
      ctx.clip();
      const img = this.loadImage(imgUrls[0]);
      if (img) this.drawImageCover(ctx, img, x + inner, topY, w - inner * 2, imgH);
      else this.drawImagePlaceholder(ctx, x + inner, topY, w - inner * 2, imgH, '');
      ctx.restore();
      topY += imgH + inner * 0.6;
    }

    // 별점
    if (this.showStars) {
      const starSize = Math.min(w, h) * 0.06;
      this.drawStars(ctx, x + inner, topY + starSize / 2, starSize, review.goodsPt || 5, this.accentColor, this.hexAlpha(this.fgColor, 0.18));
      topY += starSize * 1.6;
    }

    // 본문 (남은 공간 - 작성자 영역)
    const nameH = this.showName ? Math.min(w, h) * 0.045 : 0;
    const productH = this.showProduct && this.getProductName(review) ? Math.min(w, h) * 0.04 : 0;
    const textBot = y + h - inner - nameH - productH - (nameH || productH ? inner * 0.4 : 0);
    if (this.showText) {
      const fs = Math.max(10, Math.min(w, h) * 0.055 * this.fontSizeScale);
      this.drawTextInRect(ctx, this.truncate(this.cleanText(review.contents), this.maxChars),
        x + inner, topY, w - inner * 2, Math.max(0, textBot - topY),
        {weight: '500', fontSize: fs, lineHeight: 1.4, color: this.fgColor, valign: 'top'});
    }

    // 푸터: 상품명 / 작성자
    let footY = y + h - inner;
    if (this.showName) {
      footY -= nameH;
      ctx.fillStyle = this.hexAlpha(this.fgColor, 0.7);
      const fs = Math.max(9, nameH * 0.7);
      ctx.font = `600 ${fs}px ${this.fontFamily}`;
      ctx.textBaseline = 'top';
      ctx.fillText(this.maskName(review.writerName || '고객') + ' 님', x + inner, footY);
    }
    if (this.showProduct && this.getProductName(review)) {
      footY -= productH;
      ctx.fillStyle = this.hexAlpha(this.fgColor, 0.5);
      const fs = Math.max(9, productH * 0.75);
      ctx.font = `500 ${fs}px ${this.fontFamily}`;
      const txt = this.getProductName(review);
      // 폭 자르기
      let s = txt;
      while (ctx.measureText(s).width > w - inner * 2 && s.length > 1) s = s.slice(0, -1);
      if (s !== txt) s = s.slice(0, -1) + '…';
      ctx.fillText(s, x + inner, footY);
    }
  };

  // 리뷰 이미지 그리드 그리기 (count: 1, 2, 4)
  drawReviewImagesGrid = (ctx, x, y, w, h, urls, count) => {
    const list = urls.slice(0, count);
    if (list.length === 0) {
      this.drawImagePlaceholder(ctx, x, y, w, h, '');
      return;
    }
    const gap = w * 0.012;
    let cells;
    if (count === 1 || list.length === 1) {
      cells = [{x, y, w, h}];
    } else if (count === 2) {
      const cw = (w - gap) / 2;
      cells = [
        {x, y, w: cw, h},
        {x: x + cw + gap, y, w: cw, h}
      ];
    } else {
      // 4-grid 2x2
      const cw = (w - gap) / 2;
      const ch = (h - gap) / 2;
      cells = [
        {x, y, w: cw, h: ch},
        {x: x + cw + gap, y, w: cw, h: ch},
        {x, y: y + ch + gap, w: cw, h: ch},
        {x: x + cw + gap, y: y + ch + gap, w: cw, h: ch}
      ];
      // 3장만 있을 경우 마지막 셀 숨김
    }
    cells.forEach((cell, i) => {
      if (i >= list.length) {
        this.drawImagePlaceholder(ctx, cell.x, cell.y, cell.w, cell.h, '');
        return;
      }
      const img = this.loadImage(list[i]);
      if (img) {
        ctx.save();
        // 라운드 클리핑
        const r = Math.min(cell.w, cell.h) * 0.02;
        this.roundRect(ctx, cell.x, cell.y, cell.w, cell.h, r);
        ctx.clip();
        this.drawImageCover(ctx, img, cell.x, cell.y, cell.w, cell.h);
        ctx.restore();
      } else {
        this.drawImagePlaceholder(ctx, cell.x, cell.y, cell.w, cell.h, '로딩 중…');
      }
    });
  };

  // 상품 정보 행 그리기 (이미지 + 이름) — 상품 이미지가 없으면 이미지 칸은 placeholder, 리뷰 이미지로 폴백하지 않음
  drawProductInfo = (ctx, x, y, w, h, review) => {
    const showImg = this.showProductImage;
    const productName = this.getProductName(review);
    const showName = this.showProduct && !!productName;
    if (!showImg && !showName) return 0;

    // 배경 카드
    const r = h * 0.18;
    ctx.fillStyle = this.hexAlpha(this.fgColor, 0.06);
    this.roundRect(ctx, x, y, w, h, r);
    ctx.fill();

    let cursorX = x + h * 0.2;
    if (showImg) {
      const imgUrl = this.getProductImageUrl(review); // 상품 이미지만 — 리뷰 이미지로 폴백 안함
      const imgSize = h * 0.7;
      const imgY = y + (h - imgSize) / 2;
      ctx.save();
      this.roundRect(ctx, cursorX, imgY, imgSize, imgSize, imgSize * 0.15);
      ctx.clip();
      const img = imgUrl ? this.loadImage(imgUrl) : null;
      if (img) {
        this.drawImageCover(ctx, img, cursorX, imgY, imgSize, imgSize);
      } else {
        // 상품 이미지 없음 → placeholder
        ctx.fillStyle = this.hexAlpha(this.fgColor, 0.12);
        ctx.fillRect(cursorX, imgY, imgSize, imgSize);
        if (!imgUrl) {
          ctx.fillStyle = this.hexAlpha(this.fgColor, 0.4);
          ctx.font = `500 ${imgSize * 0.18}px ${this.fontFamily}`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('상품', cursorX + imgSize / 2, imgY + imgSize / 2);
          ctx.textAlign = 'left';
          ctx.textBaseline = 'top';
        }
      }
      ctx.restore();
      cursorX += imgSize + h * 0.25;
    }
    if (showName) {
      ctx.fillStyle = this.fgColor;
      const fs = Math.max(11, h * 0.32);
      ctx.textBaseline = 'middle';
      ctx.fillStyle = this.accentColor;
      ctx.font = `700 ${fs * 0.6}px ${this.fontFamily}`;
      ctx.fillText('상품', cursorX, y + h * 0.32);
      ctx.fillStyle = this.fgColor;
      ctx.font = `600 ${fs * 0.85}px ${this.fontFamily}`;
      const maxW = w - (cursorX - x) - h * 0.3;
      const text = this.truncate(productName, 40);
      let s = text;
      while (ctx.measureText(s).width > maxW && s.length > 1) s = s.slice(0, -1);
      if (s !== text) s = s.slice(0, -1) + '…';
      ctx.fillText(s, cursorX, y + h * 0.65);
      ctx.textBaseline = 'top';
    }
    return h;
  };

  drawStars = (ctx, x, y, size, count, accentColor, dimColor) => {
    const gap = size * 0.2;
    for (let i = 0; i < 5; i++) {
      const cx = x + i * (size + gap) + size / 2;
      const cy = y;
      this.drawStar(ctx, cx, cy, size / 2, i < count ? accentColor : dimColor);
    }
    return 5 * size + 4 * gap;
  };

  drawStar = (ctx, cx, cy, r, color) => {
    const spikes = 5;
    const outerR = r;
    const innerR = r * 0.45;
    let rot = Math.PI / 2 * 3;
    let x = cx;
    let y = cy;
    const step = Math.PI / spikes;
    ctx.beginPath();
    ctx.moveTo(cx, cy - outerR);
    for (let i = 0; i < spikes; i++) {
      x = cx + Math.cos(rot) * outerR;
      y = cy + Math.sin(rot) * outerR;
      ctx.lineTo(x, y);
      rot += step;
      x = cx + Math.cos(rot) * innerR;
      y = cy + Math.sin(rot) * innerR;
      ctx.lineTo(x, y);
      rot += step;
    }
    ctx.lineTo(cx, cy - outerR);
    ctx.closePath();
    ctx.fillStyle = color;
    ctx.fill();
  };

  // === 템플릿: 인용 ===
  drawQuote = (ctx, canvas, review, padding) => {
    const w = canvas.width, h = canvas.height;
    const innerW = w - padding * 2;
    const reviewImgs = this.getReviewImageUrls(review);
    const hasImgGrid = this.showReviewImages && reviewImgs.length > 0;
    const hasProductRow = (this.showProductImage || (this.showProduct && this.getProductName(review)));
    const gap = padding * 0.4;

    // === 위쪽 누적 ===
    let topY = padding;
    if (hasImgGrid) {
      const imgH = h * 0.32;
      this.drawReviewImagesGrid(ctx, padding, topY, innerW, imgH, reviewImgs, this.reviewImageCount);
      topY += imgH + gap;
    } else if (this.showText) {
      // 큰 따옴표 (이미지 없고 본문 있을 때만)
      const qSize = w * 0.16;
      ctx.fillStyle = this.accentColor;
      ctx.font = `bold ${qSize}px ${this.fontFamily}`;
      ctx.textBaseline = 'top';
      ctx.fillText('“', padding, topY - qSize * 0.05);
      topY += qSize * 0.55;
    }

    // === 아래쪽 누적 (위로) ===
    let botY = h - padding;
    // 핸들/로고는 drawFooter 가 뒤에 그리므로 공간 예약
    if (this.showLogo) botY -= w * 0.04;
    if (this.showName) {
      const nameFs = w * 0.025;
      botY -= nameFs * 1.4;
      ctx.fillStyle = this.hexAlpha(this.fgColor, 0.7);
      ctx.font = `500 ${nameFs}px ${this.fontFamily}`;
      ctx.textBaseline = 'top';
      ctx.fillText(`— ${this.maskName(review.writerName || '고객')} 님`, padding, botY);
      botY -= gap * 0.5;
    }
    if (this.showStars) {
      const starSize = w * 0.04;
      botY -= starSize * 1.1;
      this.drawStars(ctx, padding, botY + starSize / 2, starSize, review.goodsPt || 5, this.accentColor, this.hexAlpha(this.fgColor, 0.2));
      botY -= gap * 0.5;
    }
    if (hasProductRow) {
      const productH = w * 0.13;
      botY -= productH;
      this.drawProductInfo(ctx, padding, botY, innerW, productH, review);
      botY -= gap;
    }

    // === 본문 (남은 영역) ===
    if (this.showText) {
      const availableH = botY - topY;
      const baseFs = w * 0.05 * this.fontSizeScale;
      this.drawTextInRect(ctx, this.truncate(this.cleanText(review.contents), this.maxChars),
        padding, topY, innerW, availableH,
        {weight: '600', fontSize: baseFs, lineHeight: 1.5, color: this.fgColor, valign: hasImgGrid ? 'top' : 'top'});
    }
  };

  // === 템플릿: 카드 ===
  drawCard = (ctx, canvas, review, padding) => {
    const w = canvas.width, h = canvas.height;
    const reviewImgs = this.getReviewImageUrls(review);
    const hasImgGrid = this.showReviewImages && reviewImgs.length > 0;
    const hasProductRow = (this.showProductImage || (this.showProduct && this.getProductName(review)));

    const cardX = padding;
    const cardY = padding * 0.7;
    const cardW = w - padding * 2;
    const cardH = h - cardY - padding * (this.showLogo ? 1.4 : 0.7);
    const radius = w * 0.03;
    const innerPad = padding * 0.7;
    const innerW = cardW - innerPad * 2;
    const gap = innerPad * 0.5;

    // 카드 박스
    ctx.fillStyle = this.bgColor.startsWith('linear-gradient') ? '#FFFFFF' : this.lighten(this.bgColor, 8);
    this.roundRect(ctx, cardX, cardY, cardW, cardH, radius);
    ctx.fill();

    // === 위쪽 누적 ===
    let topY = cardY + innerPad;
    if (hasImgGrid) {
      const gridH = cardH * 0.36;
      this.drawReviewImagesGrid(ctx, cardX + innerPad, topY, innerW, gridH, reviewImgs, this.reviewImageCount);
      topY += gridH + gap;
    } else {
      ctx.fillStyle = this.accentColor;
      ctx.font = `700 ${w * 0.035}px ${this.fontFamily}`;
      ctx.textBaseline = 'top';
      ctx.fillText('REVIEW', cardX + innerPad, topY);
      topY += w * 0.06;
    }
    if (this.showStars) {
      const starSize = w * 0.038;
      this.drawStars(ctx, cardX + innerPad, topY + starSize / 2, starSize, review.goodsPt || 5, this.accentColor, '#E5E7EB');
      topY += starSize * 1.6;
    }

    // === 아래쪽 누적 ===
    let botY = cardY + cardH - innerPad;
    if (hasProductRow) {
      const productH = w * 0.13;
      botY -= productH;
      this.drawProductInfo(ctx, cardX + innerPad, botY, innerW, productH, review);
      botY -= gap;
    }
    if (this.showName) {
      const nameFs = w * 0.026;
      botY -= nameFs * 1.4;
      // 구분선
      ctx.strokeStyle = this.hexAlpha(this.fgColor, 0.12);
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(cardX + innerPad, botY - 6);
      ctx.lineTo(cardX + cardW - innerPad, botY - 6);
      ctx.stroke();
      ctx.fillStyle = this.fgColor;
      ctx.font = `600 ${nameFs}px ${this.fontFamily}`;
      ctx.textBaseline = 'top';
      ctx.fillText(this.maskName(review.writerName || '고객') + ' 님', cardX + innerPad, botY);
      botY -= gap;
    }

    // === 본문 (남은 영역) ===
    if (this.showText) {
      const availableH = botY - topY;
      const baseFs = w * 0.038 * this.fontSizeScale;
      this.drawTextInRect(ctx, this.truncate(this.cleanText(review.contents), this.maxChars),
        cardX + innerPad, topY, innerW, availableH,
        {weight: '500', fontSize: baseFs, lineHeight: 1.6, color: this.fgColor, valign: 'top'});
    }
  };

  // === 템플릿: 포토 ===
  drawPhoto = (ctx, canvas, review, padding) => {
    const w = canvas.width, h = canvas.height;
    const innerW = w - padding * 2;
    const reviewImgs = this.getReviewImageUrls(review);
    const useGrid = this.showReviewImages && this.reviewImageCount > 1 && reviewImgs.length > 1;
    const hasProductRow = (this.showProductImage || (this.showProduct && this.getProductName(review)));
    const gap = padding * 0.4;

    // === 아래쪽 누적 ===
    let botY = h - padding * (this.showLogo ? 1.2 : 0.7);
    if (hasProductRow) {
      const productH = w * 0.13;
      botY -= productH;
      this.drawProductInfo(ctx, padding, botY, innerW, productH, review);
      botY -= gap;
    }
    if (this.showName) {
      const nameFs = w * 0.026;
      botY -= nameFs * 1.4;
      ctx.fillStyle = this.hexAlpha(this.fgColor, 0.65);
      ctx.font = `500 ${nameFs}px ${this.fontFamily}`;
      ctx.textBaseline = 'top';
      ctx.fillText(this.maskName(review.writerName || '고객') + ' 님', padding, botY);
      botY -= gap * 0.5;
    }
    if (this.showStars) {
      const starSize = w * 0.045;
      botY -= starSize * 1.5;
      this.drawStars(ctx, padding, botY + starSize / 2, starSize, review.goodsPt || 5, this.accentColor, this.hexAlpha(this.fgColor, 0.18));
      botY -= gap * 0.5;
    }

    // === 사진 영역 결정 (남은 공간의 위쪽 비율 분배) ===
    // 본문 있으면 photoH = 가용공간의 55%, 없으면 95%
    const totalAvail = botY - padding * 0.7;
    const photoH = this.showText
      ? Math.max(h * 0.3, Math.min(h * 0.6, totalAvail * 0.6))
      : Math.max(h * 0.4, totalAvail * 0.95);

    if (useGrid) {
      this.drawReviewImagesGrid(ctx, padding, 0, innerW, photoH, reviewImgs, this.reviewImageCount);
    } else {
      const imgUrl = reviewImgs[0];
      if (imgUrl) {
        const img = this.loadImage(imgUrl);
        if (img) this.drawImageCover(ctx, img, 0, 0, w, photoH);
        else this.drawImagePlaceholder(ctx, 0, 0, w, photoH, '이미지 로딩 중…');
      } else {
        this.drawImagePlaceholder(ctx, 0, 0, w, photoH, '');
      }
    }

    // === 본문 (사진 아래 ~ 푸터 위) ===
    if (this.showText) {
      const textTop = photoH + padding * 0.7;
      const availableH = botY - textTop;
      if (availableH > 0) {
        const baseFs = w * 0.038 * this.fontSizeScale;
        this.drawTextInRect(ctx, this.truncate(this.cleanText(review.contents), Math.min(this.maxChars, 200)),
          padding, textTop, innerW, availableH,
          {weight: '500', fontSize: baseFs, lineHeight: 1.5, color: this.fgColor, valign: 'top'});
      }
    }
  };

  // === 템플릿: 미니멀 ===
  drawMinimal = (ctx, canvas, review, padding) => {
    const w = canvas.width, h = canvas.height;
    const innerW = w - padding * 2;
    const reviewImgs = this.getReviewImageUrls(review);
    const hasImgGrid = this.showReviewImages && reviewImgs.length > 0;
    const hasProductRow = (this.showProductImage || (this.showProduct && this.getProductName(review)));
    const gap = padding * 0.4;

    // === 위쪽 누적 ===
    let topY = padding;
    if (hasImgGrid) {
      const imgH = h * 0.28;
      this.drawReviewImagesGrid(ctx, padding, topY, innerW, imgH, reviewImgs, this.reviewImageCount);
      topY += imgH + gap;
    }

    // === 아래쪽 누적 ===
    let botY = h - padding * (this.showLogo ? 1.1 : 0.6);
    if (hasProductRow) {
      const productH = w * 0.12;
      botY -= productH;
      this.drawProductInfo(ctx, padding, botY, innerW, productH, review);
      botY -= gap;
    }
    if (this.showName) {
      const nameFs = w * 0.026;
      botY -= nameFs * 1.4;
      ctx.fillStyle = this.hexAlpha(this.fgColor, 0.6);
      ctx.font = `500 ${nameFs}px ${this.fontFamily}`;
      ctx.textBaseline = 'top';
      ctx.fillText(this.maskName(review.writerName || '고객') + ' 님의 후기', padding, botY);
      botY -= gap * 0.5;
    }
    if (this.showStars) {
      const starSize = w * 0.035;
      botY -= starSize * 1.4;
      this.drawStars(ctx, padding, botY + starSize / 2, starSize, review.goodsPt || 5, this.accentColor, this.hexAlpha(this.fgColor, 0.18));
      botY -= gap * 0.4;
    }
    // 액센트 라인 (별점/작성자 위)
    if (this.showName || this.showStars) {
      botY -= gap * 0.6;
      ctx.strokeStyle = this.accentColor;
      ctx.lineWidth = 6;
      ctx.beginPath();
      ctx.moveTo(padding, botY);
      ctx.lineTo(padding + w * 0.12, botY);
      ctx.stroke();
      botY -= gap;
    }

    // === 본문 (남은 영역, 세로 중앙 정렬) ===
    if (this.showText) {
      const availableH = botY - topY;
      const baseFs = w * 0.055 * this.fontSizeScale;
      this.drawTextInRect(ctx, this.truncate(this.cleanText(review.contents), this.maxChars),
        padding, topY, innerW, availableH,
        {weight: '300', fontSize: baseFs, lineHeight: 1.5, color: this.fgColor, valign: 'middle'});
    }
  };

  drawFooter = (ctx, canvas, padding) => {
    const w = canvas.width, h = canvas.height;
    const label = this.customLogo || (this.store && this.store.name) || '';
    if (!label) return;
    ctx.fillStyle = this.hexAlpha(this.fgColor, 0.45);
    ctx.font = `600 ${w * 0.022}px ${this.fontFamily}`;
    ctx.textAlign = 'right';
    ctx.textBaseline = 'bottom';
    ctx.fillText('@' + label, w - padding, h - padding * 0.35);
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
  };

  // === 유틸 ===
  hexAlpha = (hex, alpha) => {
    if (!hex || hex[0] !== '#') return hex;
    const c = hex.replace('#', '');
    const r = parseInt(c.substring(0, 2), 16);
    const g = parseInt(c.substring(2, 4), 16);
    const b = parseInt(c.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  lighten = (hex, percent) => {
    if (!hex || hex[0] !== '#') return hex;
    const c = hex.replace('#', '');
    let r = parseInt(c.substring(0, 2), 16);
    let g = parseInt(c.substring(2, 4), 16);
    let b = parseInt(c.substring(4, 6), 16);
    r = Math.min(255, r + Math.round((255 - r) * (percent / 100)));
    g = Math.min(255, g + Math.round((255 - g) * (percent / 100)));
    b = Math.min(255, b + Math.round((255 - b) * (percent / 100)));
    return `rgb(${r}, ${g}, ${b})`;
  };

  maskName = (name) => {
    if (!name) return '';
    if (name.length <= 1) return name;
    if (name.length === 2) return name[0] + '*';
    return name[0] + '*'.repeat(name.length - 2) + name[name.length - 1];
  };

  roundRect = (ctx, x, y, w, h, r) => {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
  };

  // === 드래그 오버레이 렌더링 ===
  renderDragOverlays = () => {
    if (!this.canvasRef.current || !this.displaySize.w) return null;
    const r = this.currentRatio;
    const scale = this.displaySize.w / r.w;
    return (
      <div className="rti-overlay">
        {this.sortedElements().map(el => {
          if (!this.isElementVisible(el)) return null;
          const isSel = this.selectedId === el.id;
          const isCustom = this.isCustomElement(el);
          return (
            <div key={el.id}
                 className={`rti-elem ${isSel ? 'is-selected' : ''} ${isCustom ? 'is-custom' : ''}`}
                 style={{
                   left: `${el.x * scale}px`,
                   top: `${el.y * scale}px`,
                   width: `${el.w * scale}px`,
                   height: `${el.h * scale}px`
                 }}
                 onMouseDown={(e) => this.startDrag(e, el, 'move')}
                 onClick={(e) => { e.stopPropagation(); this.selectElement(el.id); }}
                 onDoubleClick={(e) => {
                   if (el.type === 'customText') { e.stopPropagation(); this.editTextPrompt(el); }
                   else if (el.type === 'customImage') { e.stopPropagation(); this.openReplaceImage(el.id); }
                 }}>
              <span className="rti-elem__label">{el.label}</span>
              {isSel && (
                <>
                  <span className="rti-handle rti-handle--nw" onMouseDown={(e) => this.startDrag(e, el, 'resize-nw')}/>
                  <span className="rti-handle rti-handle--ne" onMouseDown={(e) => this.startDrag(e, el, 'resize-ne')}/>
                  <span className="rti-handle rti-handle--sw" onMouseDown={(e) => this.startDrag(e, el, 'resize-sw')}/>
                  <span className="rti-handle rti-handle--se" onMouseDown={(e) => this.startDrag(e, el, 'resize-se')}/>
                  {isCustom && (
                    <div className="rti-elemtool" onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
                      {el.type === 'customText' && (
                        <button className="rti-elemtool__btn" onClick={() => this.editTextPrompt(el)} title="텍스트 편집">
                          <FeatherIcon icon="edit-2" size="12"/>
                        </button>
                      )}
                      {el.type === 'customImage' && (
                        <button className="rti-elemtool__btn" onClick={() => this.openReplaceImage(el.id)} title="이미지 교체">
                          <FeatherIcon icon="refresh-cw" size="12"/>
                        </button>
                      )}
                      <button className="rti-elemtool__btn rti-elemtool__btn--danger" onClick={this.deleteSelected} title="삭제">
                        <FeatherIcon icon="trash-2" size="12"/>
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  // === 내보내기 ===
  // 모든 피드를 순회하며 caller(idx, dataUrl) 호출 — 순회 후 원래 피드 복원
  forEachFeed = async (callback) => {
    const orig = this.currentFeedIdx;
    for (let i = 0; i < this.feedCount; i++) {
      this.setCurrentFeed(i);
      // 캔버스 다음 그림 사이클 대기 (await microtask + rAF)
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      this.drawCanvas();
      await new Promise(resolve => requestAnimationFrame(resolve));
      const canvas = this.canvasRef.current;
      if (canvas) {
        const dataUrl = canvas.toDataURL('image/png', 0.95);
        await callback(i, dataUrl);
      }
    }
    this.setCurrentFeed(orig);
  };

  downloadImage = async () => {
    const canvas = this.canvasRef.current;
    if (!canvas) return;
    const reviewer = this.selectedReview ? (this.selectedReview.writerName || 'review') : 'review';
    const ratioStr = this.ratioVal.replace(':', 'x');

    if (this.feedCount > 1) {
      // 모든 피드 순차 다운로드
      this.isExporting = true;
      try {
        await this.forEachFeed(async (i, dataUrl) => {
          const a = document.createElement('a');
          a.href = dataUrl;
          a.download = `insta-${this.template}-${ratioStr}-${reviewer}-${String(i + 1).padStart(2, '0')}of${this.feedCount}.png`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          // 브라우저 다운로드 다이얼로그 충돌 방지
          await new Promise(resolve => setTimeout(resolve, 200));
        });
        toast.success(`${this.feedCount}개 피드가 다운로드되었습니다.`);
      } finally {
        this.isExporting = false;
      }
      return;
    }

    const url = canvas.toDataURL('image/png', 0.95);
    const a = document.createElement('a');
    a.href = url;
    a.download = `insta-${this.template}-${ratioStr}-${reviewer}-${Date.now()}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    toast.success('이미지가 다운로드되었습니다.');
  };

  uploadToLibrary = async () => {
    const canvas = this.canvasRef.current;
    if (!canvas || !this.hasStore) return;
    this.isExporting = true;
    try {
      const reviewer = this.selectedReview ? (this.selectedReview.writerName || 'review') : 'review';

      const uploadOne = async (idx, dataUrl) => {
        const base64 = dataUrl.split(',')[1];
        const cafe24Res = await this.props.base64UploadImages({
          store_id: this.store._id,
          base64Imgs: [{image: base64}]
        });
        if (cafe24Res && cafe24Res.error) throw new Error(cafe24Res.error.message);
        if (!cafe24Res || !cafe24Res.images || !cafe24Res.images.length) throw new Error('업로드 실패');
        const url = cafe24Res.images[0].path;
        const suffix = this.feedCount > 1 ? `-${String(idx + 1).padStart(2, '0')}of${this.feedCount}` : '';
        try {
          await this.props.addMyImage({
            store_id: this.store._id,
            shopNo: this.store.shopNo || 1,
            name: `insta-${this.template}-${reviewer}${suffix}.png`,
            url, size: 0,
            width: this.currentRatio.w, height: this.currentRatio.h,
            source: 'instaReview',
            tags: ['insta', this.template, ...(this.feedCount > 1 ? ['carousel'] : [])]
          });
        } catch (e) {}
      };

      if (this.feedCount > 1) {
        await this.forEachFeed(uploadOne);
        toast.success(`${this.feedCount}개 피드가 내 이미지에 저장되었습니다.`);
      } else {
        const dataUrl = canvas.toDataURL('image/png', 0.95);
        await uploadOne(0, dataUrl);
        toast.success('내 이미지에 저장되었습니다.');
      }
    } catch (e) {
      toast.error(e.message || '업로드 실패');
    } finally {
      this.isExporting = false;
    }
  };

  // === 렌더 ===
  render() {
    const r = this.currentRatio;
    return (
      <div className="main-content">
        <PageTitle/>
        <div className="widget-box rti-page">

          <div className="rti-header">
            <div className="rti-header__title">
              <p>리뷰 데이터로 인스타그램에 올릴 이미지를 만듭니다. 비율·템플릿·색상을 선택하고 다운로드 또는 내 이미지로 저장하세요.</p>
            </div>
            <div className="rti-header__cta">
              <Button theme="light"
                      disabled={(this.multiMode ? this.effectiveReviews.length === 0 : !this.selectedReview) || this.isExporting}
                      onClick={this.uploadToLibrary}>
                <FeatherIcon icon={this.isExporting ? 'loader' : 'image'} size="14"/>
                <span> {this.isExporting ? '저장 중…' : '내 이미지에 저장'}</span>
              </Button>
              <Button theme="primary"
                      disabled={this.multiMode ? this.effectiveReviews.length === 0 : !this.selectedReview}
                      onClick={this.downloadImage}>
                <FeatherIcon icon="download" size="14"/><span> 다운로드</span>
              </Button>
            </div>
          </div>

          <div className="rti-layout">
            {/* 좌: 리뷰 목록 */}
            <div className="rti-panel rti-panel--reviews">
              <div className="rti-panel__head">
                <FeatherIcon icon="message-square" size="14"/>
                <span>리뷰 선택</span>
              </div>
              <div className="rti-panel__body">
                <div className="rti-search">
                  <FeatherIcon icon="search" size="14"/>
                  <FormInput placeholder="리뷰 내용/작성자 검색" value={this.reviewsKeyword} onChange={this.onKeywordChange}/>
                </div>
                <div className="rti-starfilter">
                  {[5, 4, 3, 0].map(n => (
                    <button key={n}
                            className={`rti-starchip ${this.reviewsMinStar === n ? 'is-on' : ''}`}
                            onClick={() => this.setMinStar(n)}>
                      {n === 0 ? '전체' : `${n}★ 이상`}
                    </button>
                  ))}
                  <button className={`rti-starchip rti-starchip--photo ${this.photoOnly ? 'is-on' : ''}`}
                          onClick={this.togglePhotoOnly}
                          title="이미지가 첨부된 리뷰만">
                    <FeatherIcon icon="camera" size="11"/> 포토리뷰
                  </button>
                </div>
                <div className="rti-multibar">
                  <label className="rti-multitoggle">
                    <input type="checkbox" checked={this.multiMode} onChange={this.toggleMultiMode}/>
                    <FeatherIcon icon="grid" size="12"/> 다중 리뷰
                  </label>
                  {this.multiMode && (
                    <FormSelect className="rti-multilayout" value={this.multiLayout}
                                onChange={(e) => this.setMultiLayout(e.target.value)}>
                      <option value="1x1">1×1 (1장)</option>
                      <option value="2x1">2×1 (2장 가로)</option>
                      <option value="1x2">1×2 (2장 세로)</option>
                      <option value="1x3">1×3 (3장 가로)</option>
                      <option value="3x1">3×1 (3장 세로)</option>
                      <option value="2x2">2×2 (4장)</option>
                      <option value="2x3">2×3 (6장 가로)</option>
                      <option value="3x2">3×2 (6장 세로)</option>
                    </FormSelect>
                  )}
                  {this.multiMode && (
                    <span className="rti-multicount">{this.selectedReviewIds.length} / {this.maxCellsForLayout()}</span>
                  )}
                </div>
                {this.reviewsLoading ? (
                  <div className="rti-empty"><FeatherIcon icon="loader" size="28"/></div>
                ) : this.reviews.length === 0 ? (
                  <div className="rti-empty">
                    <FeatherIcon icon="inbox" size="36"/>
                    <div>조건에 맞는 리뷰가 없습니다.</div>
                  </div>
                ) : (
                  <div className="rti-reviewlist">
                    {this.reviews.map(rv => {
                      const isMulti = this.multiMode;
                      const isSel = isMulti
                        ? this.selectedReviewIds.includes(rv._id)
                        : (this.selectedReview && this.selectedReview._id === rv._id);
                      const multiOrder = isMulti ? this.selectedReviewIds.indexOf(rv._id) + 1 : 0;
                      const imgUrls = this.getReviewImageUrls(rv);
                      const thumbs = imgUrls.slice(0, 3);
                      return (
                        <div key={rv._id}
                             className={`rti-rcard ${isSel ? 'is-on' : ''}`}
                             onClick={() => this.selectReview(rv)}>
                          {isMulti && (
                            <span className={`rti-rcard__check ${isSel ? 'is-on' : ''}`}>
                              {multiOrder > 0 ? multiOrder : <FeatherIcon icon="square" size="11"/>}
                            </span>
                          )}
                          <div className="rti-rcard__head">
                            <span className="rti-rcard__star">★ {rv.goodsPt || 5}</span>
                            <span className="rti-rcard__name">{this.maskName(rv.writerName || '고객')}</span>
                            {imgUrls.length > 0 && (
                              <span className="rti-rcard__photoflag" title="포토리뷰">
                                <FeatherIcon icon="camera" size="10"/> {imgUrls.length}
                              </span>
                            )}
                            <span className="rti-rcard__date">{rv.displayAt ? moment(rv.displayAt).format('YY.MM.DD') : ''}</span>
                          </div>
                          {thumbs.length > 0 && (
                            <div className="rti-rcard__thumbs">
                              {thumbs.map((t, i) => (
                                <span key={i} className="rti-rcard__thumb" style={{backgroundImage: `url("${t}")`}}/>
                              ))}
                            </div>
                          )}
                          <div className="rti-rcard__text">
                            {this.truncate(this.cleanText(rv.contents), 90)}
                          </div>
                          {rv.orderProductName && (
                            <div className="rti-rcard__product">{this.truncate(rv.orderProductName, 40)}</div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
                {this.reviewsTotalPages > 1 && (
                  <div className="rti-pager">
                    <Button size="sm" theme="light" disabled={this.reviewsPage <= 1}
                            onClick={() => this.goReviewsPage(this.reviewsPage - 1)}>
                      <FeatherIcon icon="chevron-left" size="14"/>
                    </Button>
                    <span>{this.reviewsPage} / {this.reviewsTotalPages}</span>
                    <Button size="sm" theme="light" disabled={this.reviewsPage >= this.reviewsTotalPages}
                            onClick={() => this.goReviewsPage(this.reviewsPage + 1)}>
                      <FeatherIcon icon="chevron-right" size="14"/>
                    </Button>
                  </div>
                )}
              </div>
            </div>

            {/* 중: 캔버스 */}
            <div className="rti-panel rti-panel--canvas">
              <div className="rti-panel__head">
                <FeatherIcon icon="image" size="14"/>
                <span>미리보기</span>
                <span className="rti-panel__sub">{r.label} · {r.w}×{r.h}px</span>
              </div>
              <div className="rti-panel__body rti-canvasarea" ref={this.areaRef} onWheel={this.onWheel}>
                <div className="rti-addbar" onClick={(e) => e.stopPropagation()}>
                  <button className="rti-addbtn" onClick={this.addCustomText} title="텍스트 추가">
                    <FeatherIcon icon="type" size="13"/><span> 텍스트</span>
                  </button>
                  <button className="rti-addbtn" onClick={this.openCustomImagePicker} title="이미지 추가">
                    <FeatherIcon icon="image" size="13"/><span> 이미지</span>
                  </button>
                </div>
                {(this.multiMode ? this.effectiveReviews.length === 0 : !this.selectedReview) ? (
                  <div className="rti-empty">
                    <FeatherIcon icon="message-square" size="48"/>
                    <div>{this.multiMode ? '좌측에서 리뷰를 선택하세요 (다중 선택 가능).' : '좌측에서 리뷰를 선택하면 이미지가 생성됩니다.'}</div>
                  </div>
                ) : (
                  <div className={`rti-canvasframe ${!this.displaySize.w ? 'is-fit' : ''}`}
                       style={
                         this.displaySize.w
                           ? { width: `${this.displaySize.w}px`, height: `${this.displaySize.h}px` }
                           : {}
                       }
                       onClick={(e) => { if (e.target === e.currentTarget) this.deselectElement(); }}>
                    <canvas ref={this.canvasRef}/>
                    {this.renderDragOverlays()}
                  </div>
                )}
                {this.selectedReview && (
                  <div className="rti-zoombar" onClick={(e) => e.stopPropagation()}>
                    <button className="rti-zoombtn" onClick={this.zoomOut} disabled={this.zoom <= 0.25} title="축소 (Ctrl + 휠↓)">
                      <FeatherIcon icon="minus" size="14"/>
                    </button>
                    <button className="rti-zoombtn rti-zoombtn--label" onClick={this.zoomFit} title="화면에 맞춤 (100%)">
                      {Math.round(this.zoom * 100)}%
                    </button>
                    <button className="rti-zoombtn" onClick={this.zoomIn} disabled={this.zoom >= 4} title="확대 (Ctrl + 휠↑)">
                      <FeatherIcon icon="plus" size="14"/>
                    </button>
                    <span className="rti-zoombtn__sep"/>
                    <button className="rti-zoombtn" onClick={this.resetLayout} title="배치 초기화 (현재 템플릿 기본값)">
                      <FeatherIcon icon="rotate-ccw" size="13"/>
                    </button>
                  </div>
                )}

                {this.feedCount > 1 && this.selectedReview && (
                  <div className="rti-feedbar" onClick={(e) => e.stopPropagation()}>
                    <button className="rti-zoombtn" onClick={this.prevFeed} disabled={this.currentFeedIdx === 0} title="이전 피드">
                      <FeatherIcon icon="chevron-left" size="14"/>
                    </button>
                    <div className="rti-feeddots">
                      {Array.from({length: this.feedCount}).map((_, i) => (
                        <button key={i}
                                className={`rti-feeddot ${i === this.currentFeedIdx ? 'is-on' : ''}`}
                                onClick={() => this.setCurrentFeed(i)}
                                title={`피드 ${i + 1}`}>
                          <span>{i + 1}</span>
                        </button>
                      ))}
                    </div>
                    <button className="rti-zoombtn" onClick={this.nextFeed} disabled={this.currentFeedIdx >= this.feedCount - 1} title="다음 피드">
                      <FeatherIcon icon="chevron-right" size="14"/>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* 우: 스타일 */}
            <div className="rti-panel rti-panel--style">
              <div className="rti-panel__head">
                <FeatherIcon icon="sliders" size="14"/>
                <span>스타일</span>
              </div>
              <div className="rti-panel__body">
                <div className="rti-section">
                  <div className="rti-section__label">비율</div>
                  <div className="rti-ratiochips">
                    {RATIOS.map(rt => (
                      <button key={rt.value}
                              className={`rti-chip ${this.ratioVal === rt.value ? 'is-on' : ''}`}
                              onClick={() => this.setRatio(rt.value)}>
                        {rt.label}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="rti-section">
                  <div className="rti-section__label">템플릿</div>
                  <div className="rti-tplgrid">
                    {TEMPLATES.map(tp => (
                      <button key={tp.value}
                              className={`rti-tplcard ${this.template === tp.value ? 'is-on' : ''}`}
                              onClick={() => this.setTemplate(tp.value)}>
                        <FeatherIcon icon={tp.icon} size="18"/>
                        <span>{tp.label}</span>
                      </button>
                    ))}
                  </div>
                </div>

                <div className="rti-section">
                  <div className="rti-section__label">피드(슬라이드)</div>
                  <div className="rti-rangerow">
                    <span>피드 수</span>
                    <input type="range" min="1" max="10" step="1"
                           value={this.feedCount}
                           onChange={(e) => this.setFeedCount(e.target.value)}/>
                    <b>{this.feedCount}장</b>
                  </div>
                  {this.feedCount > 1 && (
                    <>
                      <div className="rti-rangerow">
                        <span>스타일</span>
                        <div className="rti-imgcounts">
                          {[
                            {v: 'none', l: '없음'},
                            {v: 'dots', l: '점'},
                            {v: 'numbers', l: '숫자'},
                            {v: 'fraction', l: 'N/M'}
                          ].map(s => (
                            <button key={s.v}
                                    className={`rti-chip ${this.paginationStyle === s.v ? 'is-on' : ''}`}
                                    onClick={() => { this.paginationStyle = s.v; }}>
                              {s.l}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="rti-help" style={{fontSize: 11, color: '#9CA3AF', lineHeight: 1.5, marginTop: 6}}>
                        IG 캐러셀처럼 여러 슬라이드를 만들 수 있습니다. 다운로드 시 모든 피드를 일괄 저장하며, 다중 리뷰 모드에선 선택한 리뷰가 자동 분배됩니다.
                      </div>
                    </>
                  )}
                </div>

                <div className="rti-section">
                  <div className="rti-section__label">컬러 프리셋</div>
                  <div className="rti-presetgrid">
                    {PRESET_BG.map((p, i) => (
                      <button key={i}
                              className={`rti-preset ${this.presetIdx === i ? 'is-on' : ''}`}
                              style={{background: p.bg}}
                              onClick={() => this.setPreset(i)}
                              title={p.name}>
                        <span className="rti-preset__chip" style={{background: p.accent}}/>
                      </button>
                    ))}
                  </div>
                </div>

                <div className="rti-section">
                  <div className="rti-section__label">개별 색상</div>
                  <div className="rti-colorrow">
                    <div className="rti-colorfield">
                      <span>배경</span>
                      <input type="color"
                             value={this.bgColor.startsWith('#') ? this.bgColor : '#FFFFFF'}
                             onChange={(e) => { this.bgColor = e.target.value; }}/>
                    </div>
                    <div className="rti-colorfield">
                      <span>텍스트</span>
                      <input type="color" value={this.fgColor} onChange={(e) => { this.fgColor = e.target.value; }}/>
                    </div>
                    <div className="rti-colorfield">
                      <span>강조</span>
                      <input type="color" value={this.accentColor} onChange={(e) => { this.accentColor = e.target.value; }}/>
                    </div>
                  </div>
                </div>

                <div className="rti-section">
                  <div className="rti-section__label">폰트 / 크기</div>
                  <FormSelect value={this.fontFamily} onChange={(e) => { this.fontFamily = e.target.value; }}>
                    {FONT_FAMILIES.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
                  </FormSelect>
                  <div className="rti-rangerow">
                    <span>글자 크기</span>
                    <input type="range" min="0.7" max="1.4" step="0.05"
                           value={this.fontSizeScale}
                           onChange={(e) => { this.fontSizeScale = parseFloat(e.target.value); }}/>
                    <b>{Math.round(this.fontSizeScale * 100)}%</b>
                  </div>
                  <div className="rti-rangerow">
                    <span>본문 글자수</span>
                    <input type="range" min="60" max="280" step="10"
                           value={this.maxChars}
                           onChange={(e) => { this.maxChars = parseInt(e.target.value, 10); }}/>
                    <b>{this.maxChars}자</b>
                  </div>
                </div>

                <div className="rti-section">
                  <div className="rti-section__label">콘텐츠 요소</div>
                  <div className="rti-toggles">
                    <label><input type="checkbox" checked={this.showText} onChange={(e) => { this.showText = e.target.checked; }}/> 본문 텍스트</label>
                    <label><input type="checkbox" checked={this.showStars} onChange={(e) => { this.showStars = e.target.checked; }}/> 별점</label>
                    <label><input type="checkbox" checked={this.showName} onChange={(e) => { this.showName = e.target.checked; }}/> 작성자</label>
                    <label><input type="checkbox" checked={this.showProduct} onChange={(e) => { this.showProduct = e.target.checked; }}/> 상품명</label>
                    <label><input type="checkbox" checked={this.showProductImage} onChange={(e) => { this.showProductImage = e.target.checked; }}/> 상품 이미지</label>
                    <label><input type="checkbox" checked={this.showReviewImages} onChange={(e) => { this.showReviewImages = e.target.checked; }}/> 리뷰 이미지</label>
                    <label><input type="checkbox" checked={this.showLogo} onChange={(e) => { this.showLogo = e.target.checked; }}/> 핸들/로고</label>
                  </div>
                  {this.showReviewImages && (
                    <div className="rti-rangerow">
                      <span>이미지 수</span>
                      <div className="rti-imgcounts">
                        {[1, 2, 4].map(n => (
                          <button key={n}
                                  className={`rti-chip ${this.reviewImageCount === n ? 'is-on' : ''}`}
                                  onClick={() => { this.reviewImageCount = n; }}>
                            {n === 1 ? '1장' : n === 2 ? '2장' : '4장'}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                  <FormInput placeholder="@핸들 (비우면 스토어명 사용)" value={this.customLogo}
                             onChange={(e) => { this.customLogo = e.target.value; }}/>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* === 커스텀 이미지 피커 모달 === */}
        {this.showImagePicker && (
          <Modal open={this.showImagePicker} toggle={() => {}} size="lg" className="rti-picker">
            <ModalHeader toggle={this.closeImagePicker}>
              {this.replacingElementId ? '이미지 교체' : '이미지 선택'}
            </ModalHeader>
            <ModalBody>
              <div className="rti-picker__toolbar">
                <div className="rti-search">
                  <FeatherIcon icon="search" size="14"/>
                  <FormInput placeholder="이름 검색" value={this.pickerKeyword} onChange={this.onPickerKwChange}/>
                </div>
                <span style={{fontSize: 12, color: '#9CA3AF'}}>
                  내 이미지 라이브러리에서 선택 — 디자인 관리 &gt; 내 이미지에서 추가 가능
                </span>
              </div>
              {this.pickerLoading ? (
                <div className="rti-empty"><FeatherIcon icon="loader" size="28"/></div>
              ) : this.pickerImages.length === 0 ? (
                <div className="rti-empty">
                  <FeatherIcon icon="image" size="40"/>
                  <div>등록된 이미지가 없습니다.</div>
                </div>
              ) : (
                <div className="rti-picker__grid">
                  {this.pickerImages.map(img => (
                    <button key={img._id} className="rti-picker__item" onClick={() => this.selectImageForCustom(img)}>
                      <img src={img.url} alt={img.name}/>
                    </button>
                  ))}
                </div>
              )}
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

export default ReviewToInsta;
